import React from "react";
import "./Welcome.css";
import { Link } from "react-router-dom";

const Welcome = () => {
	return (
		<div className='uiowa-welcome'>
			<div className='overlay'>
				<div className='inner'>
					<h1>Welcome Home</h1>
					<p>
						Big Ten athletics. A world-class medical center. Renowned artists.
						Exciting things come together in Iowa City. And you'll be at the center of
						it all.
					</p>
					<Link className='btnUiowa d-flex  gap-3'>
						EXPLORE IOWA CITY
						<span>
							<i
								className='fa fa-arrow-right'
								style={{ color: "#fff" }}
								aria-hidden='true'
							></i>
						</span>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Welcome;
